import { useIsApiReady } from "@/hooks/use-api-ready";
import { promptControllerGetBaseNames } from "@/lib/gen-brain";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export const usePromptBaseNamesData = () => {
  const isApiReady = useIsApiReady();

  const { data } = useQuery({
    enabled: isApiReady,
    queryKey: queryKeys.promptBaseNames(),
    queryFn: () => promptControllerGetBaseNames().then((res) => res.data ?? []),
  });

  return {
    baseNames: data ?? [],
  };
};
